var moduleMap = {
	"./store": () => {
		return Promise.all([__webpack_require__.e(124), __webpack_require__.e(986)]).then(() => (() => ((__webpack_require__(98986)))));
	},
	"./Menu": () => {
		return Promise.all([__webpack_require__.e(124), __webpack_require__.e(440), __webpack_require__.e(42), __webpack_require__.e(718), __webpack_require__.e(811), __webpack_require__.e(667), __webpack_require__.e(902), __webpack_require__.e(462), __webpack_require__.e(126), __webpack_require__.e(78), __webpack_require__.e(443)]).then(() => (() => ((__webpack_require__(60126)))));
	},
	"./PlacementPreview": () => {
		return Promise.all([__webpack_require__.e(124), __webpack_require__.e(440), __webpack_require__.e(718), __webpack_require__.e(667), __webpack_require__.e(902), __webpack_require__.e(421), __webpack_require__.e(615), __webpack_require__.e(742), __webpack_require__.e(78), __webpack_require__.e(502)]).then(() => (() => ((__webpack_require__(19742)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});